import type { ReactNode } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";

import { useAuth } from "@/features/auth/useAuth";
import { getActiveEvent } from "@/services/api/events";
import { queryKeys } from "@/services/api/query-keys";

import { EventContext } from "./useActiveEvent";

export function EventProvider({ children }: { children: ReactNode }) {
  const { isAuthenticated } = useAuth();
  const queryClient = useQueryClient();

  const eventQuery = useQuery({
    queryKey: queryKeys.events.active,
    queryFn: getActiveEvent,
    // GET /api/eventos/ativo exige sessão — nem tenta sem uma.
    enabled: isAuthenticated,
    staleTime: 10 * 60_000,
  });

  const value = {
    event: eventQuery.data ?? null,
    eventId: eventQuery.data?.id ?? null,
    isLoading: eventQuery.isLoading,
    invalidate: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.events.active });
    },
  };

  return <EventContext.Provider value={value}>{children}</EventContext.Provider>;
}
